import { render, staticRenderFns } from "./LocalityMappingConfig.vue?vue&type=template&id=c04a24f2"
import script from "./LocalityMappingConfig.vue?vue&type=script&lang=js"
export * from "./LocalityMappingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports